import { useQuery } from '@tanstack/react-query';
import giftClient from '../../../api/gift';

type UseGiftQueryParams = {
  clockId?: string;
  clockIdf?: string;
  orderName?: string;
};

const useGiftQuery = (params: UseGiftQueryParams) => {
  const queryKey = params.clockId
    ? ['gift', 'clockId', params.clockId]
    : params.clockIdf
      ? ['gift', 'clockIdf', params.clockIdf]
      : params.orderName
        ? ['gift', 'orderName', params.orderName]
        : ['gift'];

  const enabled = !!(params.clockId || params.clockIdf || params.orderName);

  return useQuery({
    queryKey,
    queryFn: async () => giftClient.getGift(params),
    enabled,
    retry: false,
  });
};

export default useGiftQuery;
